var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "system" }, [
    _c("h2", [_vm._v("发布系统消息")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _vm._v("发给谁：\n    "),
        _c(
          "el-select",
          {
            attrs: {
              placeholder: "请选择",
              multiple: "",
              filterable: "",
              "allow-create": ""
            },
            model: {
              value: _vm.range,
              callback: function($$v) {
                _vm.range = $$v
              },
              expression: "range"
            }
          },
          _vm._l(_vm.rangeList, function(item) {
            return _c("el-option", {
              key: item.value,
              attrs: { label: item.label, value: item.value }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inputBox normal" },
      [
        _c("el-input", {
          staticStyle: { "font-size": "20px" },
          attrs: { type: "textarea", cols: "40", rows: "5", resize: "none" },
          model: {
            value: _vm.words,
            callback: function($$v) {
              _vm.words = $$v
            },
            expression: "words"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("input", { attrs: { type: "file" }, on: { change: _vm.chooseImage } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inputBox" }, [
      _c(
        "div",
        { staticClass: "imageBox" },
        _vm._l(_vm.images, function(url, index) {
          return _c("div", { key: index, staticClass: "imageItem" }, [
            _c("img", {
              attrs: { src: url.replace("_mini.jpg", ""), preview: "8" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.delImage(index)
                  }
                }
              },
              [_vm._v("删除")]
            )
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
          [_vm._v("发送")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b61a706", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b61a706","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/System.vue
// module id = null
// module chunks = 